<template>
  <div class="container">
    <div class="w1200">
      <nav>当前位置：<a @click="toAuthor">学者</a> > 学者详情</nav>
      <div class="wapper">
        <div class="leftData" v-if="detail">
          <h3>个人信息</h3>
          <p class="name">学者：{{ detail.authorName }}</p>
          <p class="jigou" v-if="detail.lastKnownInstitutionName">所属机构：{{ detail.lastKnownInstitutionName }}</p>
          <p v-if="detail.primayConcepts && detail.primayConcepts.length > 0">
            研究领域：<span v-for="(item, index) in detail.primayConcepts" :key="index">
              <span class="green" @click="toPrimaySearch(item)">{{ item }}</span>
              <label v-if="index < detail.primayConcepts.length - 1">，</label>
            </span>
          </p>
          <p v-if="detail.country && detail.country.length > 0">
            国家/地区：<span v-for="(item, index) in detail.country" :key="index">
              <span>{{ item }}</span>
              <label v-if="index < detail.country.length - 1">，</label>
            </span>
          </p>
          <p v-if="detail.language">语种：{{ detail.language }}</p>
          <h3 class="mt20" v-if="cooperatingData.length > 0">合作学者</h3>
          <ul class="cooperating">
            <li v-for="(item, index) in cooperatingData" :key="index" class="coop-author">
              <div>
                <p class="name" @click="toAuthorDetail(item.sid)">
                  {{ item.authorName }}
                </p>
                <p class="jigou line1">{{ item.lastKnownInstitutionName }}</p>
              </div>
              <div class="num">
                <p class="count" v-if="item.worksCount">合作论文数</p>
                <p>{{ item.worksCount }}</p>
              </div>

              <div class="author-content">
                <p class="mb10" v-html="item.authorName"></p>
                <p>
                  <span v-if="item.hindex != null"
                    >hindex：<label>{{ item.hindex }}</label></span
                  >
                  <span v-if="item.i10Index != null"
                    >i10Index：<label>{{ item.i10Index }}</label></span
                  >
                </p>
                <p>
                  <span v-if="item.citedByCount != null"
                    >citedByCount：<label>{{ item.citedByCount }}</label></span
                  >
                  <span v-if="item.worksCount != null"
                    >worksCount：<label>{{ item.worksCount }}</label></span
                  >
                </p>
                <p class="hui">{{ item.lastKnownInstitutionName }}</p>
              </div>
            </li>
          </ul>
          <h3 class="mt20" v-if="institutionData.length > 0">合作机构</h3>
          <ul class="cooperating">
            <li v-for="(item, index) in institutionData" :key="index">
              <p class="name noCursor">{{ item.institutionName }}</p>
              <p class="count" v-if="item.coAuthorCount">合作论文数：{{ item.coAuthorCount }}</p>
            </li>
          </ul>
          <h3 class="mt20" v-if="authorListData.length > 0">相似学者</h3>
          <ul class="xs-author">
            <li v-for="(item, index) in authorListData" :key="index">
              <p @click="toAuthorDetail(item.sid)">{{ item.authorName }}</p>
            </li>
          </ul>
          <h3 class="mt20">数据免责声明</h3>
          <div class="mzsm">页面数据均来自互联网公开来源、合作出版商和通过AI技术自动分析结果，我们不对页面数据的有效性、准确性、正确性、可靠性、完整性和及时性做出任何承诺和保证。</div>
        </div>
        <div class="rightData">
          <div class="radarData">
            <p class="h3 h3-flex">
              学者统计
              <el-popover ref="popover" placement="bottom" width="400" trigger="hover">
                <div class="tips-content">
                  <p>1.citedByCount（引用量）：该学者所有出版物的被引用次数。</p>
                  <p>2.worksCount（论文数量）：该学者发表的所有论文的数量。</p>
                  <p>3.hindex（H-指数）：如果一位学者的n篇论文中，每篇至少有 h 次引用，并且其他 (N-h) 篇论文每篇最多有 h 次引用，则该学者的索引为h。</p>
                  <p>4.i10Index（i10指数）：i10指数是指一个学者的论文被引用次数至少为10次的论文数量。</p>
                  <p>5.twoYrMeanCitedness（两年中的平均被引频次）：计算一个研究成果在发表后的两年内被其他学术作品引用的平均次数，用于评估学术影响力和期刊质量。</p>
                </div>
              </el-popover>
              <i class="el-icon-question" v-popover:popover></i>
            </p>
            <div class="radar-flex">
              <RadarEcharts :radarData="radarData"></RadarEcharts>
              <ul v-if="detail">
                <li>
                  worksCount：<span>{{ detail.worksCount }}</span>
                </li>
                <li>
                  hindex：<span>{{ detail.hindex }}</span>
                </li>
                <li>
                  i10Index：<span>{{ detail.i10Index }}</span>
                </li>
                <li>
                  citedByCount：<span>{{ detail.citedByCount }}</span>
                </li>
                <li>
                  twoYrMeanCitedness：<span>{{ detail.twoYrMeanCitedness }}</span>
                </li>
              </ul>
            </div>

            <!--  -->
          </div>
          <div class="themeData">
            <p class="h3">研究兴趣</p>
            <ThemeRiverEcharts :themeData="themeData"></ThemeRiverEcharts>
            <div class="theme-slider" v-show="this.sliderMarksArray && !isEmpty(this.sliderMarksArray)">
              <el-slider v-model="sliderVal" show-stops range :marks="sliderMarksArray" :step="stepValue" :max="maxVal" @change="slidChange" :format-tooltip="formatTooltip"> </el-slider>
            </div>
          </div>

          <div class="listData" v-loading="loading" v-if="leftData.length > 0 || listData.length > 0">
            <p class="h3">论文列表</p>
            <ul class="tab-ul" v-if="leftData">
              <li :class="{ 'ul-checked': tabVal == index }" v-for="(item, index) in leftData" :key="index" @click="handleChangeTab(index)" @mouseover="mouseoverTab(index)" @mouseout="mouseoutTab(index)">
                <div>
                  {{ item.name }}
                  <i v-if="index > 1" class="el-icon-arrow-down"></i>
                </div>

                <div class="tab-ul-two" v-if="index != 0 && index != 1">
                  <div class="tab-popover">
                    <div class="ant-popover-arrow"></div>
                    <div class="tab-popover-span">
                      <el-checkbox-group v-model="checkList">
                        <el-checkbox :label="element.onlyFlag" v-for="(element, idx) in item.items" :key="idx" @change="handleChangeCheckbox(index, idx)"
                          ><span class="line1" :title="element.name + '(' + element.result + ')'">{{ element.name }}({{ element.result }})</span></el-checkbox
                        >
                      </el-checkbox-group>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="years" v-if="tabVal == 0 && leftData.length > 0">
              <div class="select_year">
                <div class="select_year_inner">
                  <span class="year_all" :class="{ allactive: yearVal == 'all' }" @click="handleYear('all')">全部</span>
                  <span class="year_bar" :title="item.name + ':' + item.result" :class="{ active: yearVal == index }" v-for="(item, index) in yearData" :key="index" @click="handleYear(index, item)">
                    <span class="bar" :style="{ height: item.height }"></span>
                    <span class="bar_label">{{ item.name }}</span>
                  </span>
                </div>
              </div>
            </div>
            <!-- 列表 -->
            <ul class="tab-list">
              <li v-for="(item, index) in listData" :key="index">
                <div class="title line1" @click="toDetail(item.sid)" v-html="item.title"></div>
                <p v-if="item.authorList && item.authorList.length > 0">
                  学者：<span class="span-content" :class="{ green_span: element.click }" v-for="(element, idx) in item.authorList" :key="idx">
                    <span class="span_a" v-html="element.authorName" @click="toPaperAuthorDetail(element)"> </span>
                    <span v-if="idx < item.authorList.length - 1">；</span>
                    <div class="author-content">
                      <p class="mb10" v-html="element.authorName"></p>
                      <p>
                        <span
                          >hindex：<label>{{ element.hindex }}</label></span
                        >
                        <span
                          >i10Index：<label>{{ element.i10Index }}</label></span
                        >
                      </p>
                      <p>
                        <span
                          >citedByCount：<label>{{ element.citedByCount }}</label></span
                        >
                        <span
                          >worksCount：<label>{{ element.worksCount }}</label></span
                        >
                      </p>
                      <p class="hui">{{ element.lastKnownInstitutionName }}</p>
                    </div>
                  </span>
                </p>
                <p class="journal_span">
                  期刊信息：<span class="span_a" @click="toHomeDetail(item)">{{ item.journalName }}</span
                  >;<span v-if="item.year">{{ item.year }};</span>{{ item.volume }}<span v-if="item.issue">({{ item.issue }})</span>
                </p>
                <p v-if="item.issn">
                  ISSN：<span>{{ item.issn.toString() }}</span>
                </p>
                <p v-if="item.aliasName">其他刊名：<span v-html="item.aliasName"></span></p>
                <p v-if="item.doi">DOI：{{ item.doi }}</p>
                <p>
                  引用量<span class="span_p">{{ item.citedCount }}</span>
                </p>
              </li>
            </ul>
            <el-pagination v-if="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl.js";
import RadarEcharts from "@/components/radarEcharts.vue";
import ThemeRiverEcharts from "@/components/themeRiverEcharts.vue";
export default {
  components: { RadarEcharts, ThemeRiverEcharts },

  data() {
    return {
      loading: false,
      authorSid: "",
      detail: null,
      radarData: [],
      cooperatingData: [],
      institutionData: [],
      themeData: null, //研究兴趣
      sliderVal: [],
      sliderMarksArray: null,
      authorYearKeyValueBOList: null,
      stepValue: 0, //滑块离散值
      startYear: "",
      endYear: "",
      leftData: [],
      orderField: "year",
      yearData: [],
      yearVal: "all",
      tabVal: 0,
      mouseTabVal: -1,
      conceptsData: [], //主题筛选下拉框 数据
      checkList: [],
      checkName: "",

      listData: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      metricFilterList: [], //聚合参数集
      maxVal: 0,

      authorListData: [], //相似作者
    };
  },
  created() {},
  mounted() {
    this.initData();
  },
  watch: {
    // 监听路由变化，如果在同一个页面组件内只有参数变化，就重新初始化数据
    $route(to, from) {
      if (to.query.authorSid !== from.query.authorSid) {
        this.initData();
      }
    },
  },
  methods: {
    initData() {
      this.authorSid = this.$route.query.authorSid;
      this.pageNo = 1;
      this.getInfo();
      this.getCooperatingAuthor();
      this.getInstitutionDataAuthor(); //合作机构
      this.getThemeData(); //研究兴趣
      this.getAuthorListData();
      // 作者聚合
      this.getLeftData();
      this.getListData();
    },
    getAuthorListData() {
      this.$http({
        url: `api/v1/reception/author/similarAuthorList?authorSid=${this.authorSid}&size=10`,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
          this.authorListData = res.data;
        }
      });
    },
    // 获取作者信息
    getInfo() {
      this.$http({
        url: `api/v1/reception/author/authorDetail?authorSid=${this.authorSid}`,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
          this.detail = res.data;
          let text = this.detail.authorName + (this.detail.lastKnownInstitutionName ? " - " + this.detail.lastKnownInstitutionName : "");
          document.querySelector("head title").innerText = text;
          this.radarData = [this.detail.worksCount, this.detail.citedByCount, this.detail.i10Index, this.detail.twoYrMeanCitedness, this.detail.hindex];
        }
      });
    },
    // 获取合作作者
    getCooperatingAuthor() {
      this.$http({
        url: `api/v1/reception/author/cooperatingAuthorList?authorSid=${this.authorSid}`,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
          this.cooperatingData = res.data;
        }
      });
    },
    // 获取合作机构
    getInstitutionDataAuthor() {
      this.$http({
        url: `api/v1/reception/author/cooperatingInstitutionList?authorSid=${this.authorSid}`,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
          this.institutionData = res.data;
        }
      });
    },

    // 获取研究兴趣
    getThemeData() {
      this.$http({
        url: `api/v1/reception/author/getAuthorInterestById?authorSid=${this.authorSid}&startYear=${this.startYear}&endYear=${this.endYear}`,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
          // 转换成 河流图需要的格式
          let newArray = res.data.conceptYearCountList;
          if (newArray.length > 0) {
            let newYearCountList = [];
            newArray.forEach(element => {
              newYearCountList.push([element.year.toString(), element.count, element.concept]);
            });

            res.data.newYearCountList = newYearCountList;
          }
          // slider滑动数据加载
          if (!this.sliderMarksArray) {
            this.sliderMarksArray = res.data.authorConceptYearList;
            this.authorYearKeyValueBOList = res.data.authorYearKeyValueBOList;
            if (res.data.authorYearKeyValueBOList.length > 0) {
              this.maxVal = parseInt(res.data.authorYearKeyValueBOList.slice(-1)[0].key);
              this.sliderVal = [0, this.maxVal];
              this.stepValue = Math.floor(this.maxVal / (Object.keys(this.sliderMarksArray).length - 1));
            }
          }
          this.themeData = res.data;
        }
      });
    },
    // 判断对象是否是空对象
    isEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    formatTooltip(val) {
      let year;
      if (this.authorYearKeyValueBOList) {
        this.authorYearKeyValueBOList.forEach(element => {
          if (val == element.key) {
            year = element.year;
          }
        });
      }
      return year;
    },

    slidChange(val) {
      this.startYear = this.sliderMarksArray[val[0]];
      this.endYear = this.sliderMarksArray[val[1]];
      this.getThemeData();
    },
    getLeftData() {
      this.$http({
        url: `api/v1/reception/author/authorDetailThesisListAgg?authorSid=${this.authorSid}`,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
          this.leftData = res.data.left;
          if (this.leftData.length > 0) {
            this.leftData[0].name = "按年份排序";
            this.leftData.splice(1, 0, { name: "按引用量排序" });

            let maxVal = this.leftData[0].items.reduce((prev, curr) => {
              return prev.result > curr.result ? prev : curr;
            });
            this.leftData[0].items.forEach((element, index) => {
              this.leftData[0].items[index].height = ((Number(element.result) / maxVal.result) * 100).toFixed(0) + "%";
            });
            this.yearData = this.leftData[0].items;
          }
        }
      });
    },
    getListData() {
      this.loading = true;
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        authorSid: this.authorSid,
        orderField: this.orderField,
        orderType: "DESC",
        metricFilterList: this.metricFilterList,
      };
      this.$http({
        url: `api/v1/reception/author/authorDetailThesisList`,
        method: "post",
        data: postBody,
      }).then(res => {
        setTimeout(() => {
          if (res.code == 200) {
            this.loading = false;
            this.listData = res.data.recordList;
            this.total = res.data.recordCount;
          }
        }, 500);
      });
    },
    handleChangeTab(val) {
      if (val != 0 && val != 1) {
        return;
      }
      this.tabVal = val;
      if (val == 0) {
        this.yearVal = "all";
        this.orderField = "year";
      } else if (val == 1) {
        this.orderField = "citedCount";
      } else {
        this.orderField = "";
      }
      this.checkList = [];
      this.metricFilterList = [];
      this.pageNo = 1;
      this.getListData();
    },
    // 年份排序下的切换年份事件
    handleYear(val, item) {
      this.yearVal = val;
      this.metricFilterList = [];
      if (val != "all") {
        this.metricFilterList.push({
          filterField: item.filterField,
          filterValue: [item.filterValue],
          type: null,
        });
      }
      this.pageNo = 1;
      this.getListData();
    },
    handleChangeCheckbox(index, idx) {
      // 如果换了聚合选项  清空之前选的
      if (this.checkName && this.checkName != this.leftData[index].name) {
        this.checkList = [];
        // 解决清空完以后  新选的没有选中问题
        this.checkList.push(this.leftData[index].items[idx].onlyFlag);
      }
      this.checkName = this.leftData[index].name;
      this.tabVal = index;
      this.pageNo = 1;

      let array = [];
      let filterValue = [];
      if (this.checkList.length > 0) {
        this.leftData[index].items.forEach(element => {
          this.checkList.forEach(item => {
            if (element.onlyFlag == item) {
              array.push(element);
            }
          });
        });
        array.forEach(element => {
          filterValue.push(element.filterValue);
        });
        this.metricFilterList = [];
        this.metricFilterList.push({
          filterField: array[0].filterField,
          filterValue: filterValue,
          type: null,
        });
      }

      this.getListData();
    },
    mouseoverTab(index) {
      this.mouseTabVal = index;
    },
    mouseoutTab() {
      this.mouseTabVal = -1;
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getListData();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getListData();
    },
    // 作者文章详情
    toDetail(sid) {
      let _url = this.$router.resolve({
        path: "/articleDetail",
        query: { sid: sid },
      });
      window.open(_url.href, "_self");
    },
    // 作者详情
    toAuthorDetail(authorSid) {
      let _url = this.$router.resolve({
        path: "/authorDetail",
        query: { authorSid: authorSid },
      });
      window.open(_url.href, "_self");
    },
    toPaperAuthorDetail(item) {
      if (item.click) {
        if (window.__POWERED_BY_QIANKUN__) {
          // 在 Qiankun 主应用环境中，跳转主应用的路由（使用当前所在主应用的域名）
          const url = window.location.origin + `/authorDetail?authorSid=${item.sid}`;
          window.open(url, "_self");
        } else {
          // 独立运行时的跳转
          window.open(baseurl.jyxUrl + `authorDetail?authorSid=${item.sid}`, "_self");
        }
      }
    },
    // 期刊详情
    toHomeDetail(item) {
      let _url = this.$router.resolve({
        path: "homeDetail",
        query: { sid: item.journalSid },
      });
      window.open(_url.href, "_self");
    },

    toHome() {
      this.$router.push({ path: "/articleSearch" });
    },
    toAuthor() {
      this.$router.back();
    },
    toPrimaySearch(val) {
      sessionStorage.setItem(
        "search-author-keyword",
        JSON.stringify({
          word: val,
          form: "domain",
        }),
      );
      this.$router.push({ path: "/author" });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  min-height: calc(100vh - 154px);
  .w1200 {
    nav {
      padding: 20px 0;
      font-size: 14px;
      color: #999999;
    }
    .wapper {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      .leftData {
        background: #fff;
        width: 350px;
        padding: 20px;
        h3 {
          font-size: 18px;
          padding-bottom: 10px;
          border-bottom: 2px solid #2d8cf0;
          margin-bottom: 20px;
        }
        > p {
          margin-bottom: 5px;
          line-height: 25px;
          color: #666;
          .green {
            color: #2d8cf0;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }

          &:last-of-type {
            margin-bottom: 0;
          }
        }
        .cooperating {
          .coop-author {
            display: flex;
          }
          li {
            border-bottom: 1px dashed #d4d4d4;
            padding: 10px 0;
            position: relative;

            &:last-of-type {
              border: none;
              padding-bottom: 0;
            }
            &:nth-of-type(1) {
              padding-top: 0;
            }
            > div {
              min-width: 0;
            }
            .name {
              cursor: pointer;
              font-weight: bold;
              margin-bottom: 5px;
              &:hover {
                color: #2d8cf0;
              }
            }
            .jigou {
              color: #666;
              font-size: 14px;
            }
            .num {
              margin-left: auto;
              color: #2d8cf0;
              text-align: center;
              font-size: 14px;
              min-width: 70px;
            }
            .count {
              margin-top: 5px;
              font-size: 14px;
              color: #666;
            }
            .noCursor {
              cursor: text;
              &:hover {
                color: #333;
              }
            }

            &:hover {
              .author-content {
                display: inline-block;
              }
            }
          }
        }
        .xs-author {
          li {
            border-bottom: 1px dashed #d4d4d4;
            padding: 10px 0;

            p {
              position: relative;
              padding-left: 15px;
              cursor: pointer;
              &:hover {
                color: #2d8cf0;
                text-decoration: underline;
              }
              &::after {
                content: "";
                width: 6px;
                height: 6px;
                background: #2d8cf0;
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -3px;
              }
            }

            &:last-of-type {
              border: none;
              padding-bottom: 0;
            }
            &:nth-of-type(1) {
              padding-top: 0;
            }
          }
        }
        .mzsm {
          font-size: 14px;
          color: #7c7c7c;
        }
      }
      .author-content {
        position: absolute;
        background: #fff;
        box-shadow: 0 0 5px #d3d3d3;
        display: none;
        padding: 10px;
        z-index: 9999;
        top: -30px;
        right: -210px;
        min-width: 300px;
        .mb10 {
          font-size: 16px;
          margin-bottom: 10px !important;
        }
        .hui {
          margin-top: 5px !important;
          white-space: pre-wrap;
        }
        p {
          font-size: 14px;
          margin: 0 !important;
          span {
            position: relative;
            &:first-of-type {
              margin-right: 14px;
              &::before {
                content: "";
                position: absolute;
                width: 1px;
                height: 14px;
                background: #ccc;
                right: -7px;
                top: 50%;
                margin-top: -7px;
              }
            }
            label {
              color: #2d8cf0;
            }
          }
        }
      }
      .rightData {
        flex: 1;
        min-width: 0;
        margin-left: 10px;
        .h3 {
          font-size: 18px;
          font-weight: bold;
          padding: 20px;
          padding-bottom: 0;
        }
        .radarData {
          background: #fff;

          .h3-flex {
            display: flex;
            align-items: center;
            i {
              margin-left: auto;
            }
          }
          .radar-flex {
            display: flex;
            ul {
              width: 300px;
              font-size: 14px;
              li {
                margin-top: 10px;
                span {
                  background: #ebebeb;
                  padding: 0 5px;
                }
              }
            }
          }
        }
        .themeData {
          background: #fff;
          margin-top: 10px;
          width: 840px;
          height: 440px;

          .theme-slider {
            padding: 0 50px;
            margin-top: -20px;
            ::v-deep .el-slider__marks-text {
              width: 50px;
              text-align: center;
            }
          }
        }
        .listData {
          background: #fff;
          margin-top: 10px;
          .tab-ul {
            margin-top: 20px;
            padding: 0 20px;
            display: flex;
            align-items: center;
            > li {
              cursor: pointer;
              display: flex;
              align-items: center;
              border: 1px solid #d4d4d4;
              border-right: 0;
              padding: 7px 10px;
              position: relative;
              &:last-of-type {
                border: 1px solid #d4d4d4;
              }
              &:hover {
                .tab-ul-two {
                  display: inline-block;
                }
              }
              i {
                margin-left: 5px;
              }
              .tab-ul-two {
                display: none;
                position: absolute;
                z-index: 99;
                top: 30px;
                left: -65px;
                padding: 10px;
                padding-top: 20px;

                .tab-popover {
                  padding: 10px 20px;
                  background: #fff;
                  box-shadow: 4px 4px 40px #d8d8d8;
                  .ant-popover-arrow {
                    left: 50%;
                    transform: translateX(-50%) rotate(45deg);
                    top: 16px;
                    border-color: #fff transparent transparent #fff;
                    box-shadow: -2px -2px 5px rgba(0, 0, 0, 0.06);
                    position: absolute;
                    display: block;
                    width: 8px;
                    height: 8px;
                    background: transparent;
                    border-style: solid;
                    border-width: 4px;
                  }

                  .tab-popover-span {
                    overflow-y: auto;
                    max-height: 300px;
                    .el-checkbox {
                      display: flex;
                      align-items: center;
                      margin-bottom: 5px;
                      &:last-of-type {
                        margin: 0;
                      }
                      .line1 {
                        display: block;
                        width: 200px;
                      }
                    }
                  }
                }
              }
            }
            .ul-checked {
              background: #2d8cf0;
              border: 1px solid #2d8cf0;
              color: #fff;
            }
          }
          .years {
            width: calc(100% - 50px);
            max-width: calc(100% - 50px);
          }
          .select_year {
            overflow-x: auto;
            padding: 15px 20px;
            padding-bottom: 0;
            .select_year_inner {
              display: flex;
              align-items: stretch;
              height: 44px;
              box-sizing: content-box;
              .year_all {
                margin-right: 12px;
                border-radius: 2px;
                border: 1px solid #666;
                font-size: 12px;
                color: #666;
                cursor: pointer;
                width: 25px;
                height: 44px;
                text-align: center;
                display: flex;
                align-items: center;
              }
              .allactive {
                border-color: #2d8cf0;
                background: #2d8cf0;
                color: #fff;
              }
              .active {
                background: #dedede !important;
                .bar {
                  background: #ffe98e !important;
                }
              }
              .year_bar {
                width: 22px;
                max-width: 22px;
                min-width: 22px;
                position: relative;
                margin-right: 2px;
                display: flex;
                align-items: flex-end;
                flex-grow: 1;
                background: #f1f1f1;
                cursor: pointer;
                &:hover {
                  background: #dedede;
                  .bar {
                    background: #ffe98e;
                  }
                }
                .bar {
                  background: #ced5fe;
                  display: block;
                  width: 100%;
                  min-height: 1px;
                }
                .bar_label {
                  color: #666;
                  width: 100%;
                  text-align: center;
                  transform: rotate(90deg) scale(0.8);
                  display: block;
                  position: absolute;
                  top: 13%;
                  white-space: nowrap;
                }
              }
            }
          }
          .tab-list {
            padding: 0 20px;
            margin-top: 15px;
            li {
              padding: 20px 0;
              border-bottom: 1px dashed #eeeeee;
              .title {
                color: #333;
                font-size: 18px;
                font-weight: bold;
                cursor: pointer;
                &:hover {
                  background-image: linear-gradient(to right, #006eb3, #2d8cf0);
                  background-clip: text;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                  label {
                    -webkit-text-fill-color: initial;
                  }
                }
              }
              .span-content {
                position: relative;
                .author-content {
                  top: 30px;
                  left: 0px;
                }
              }
              .green_span {
                cursor: pointer;
                &:hover {
                  .span_a {
                    text-decoration: underline;
                  }
                  transition: all 1s;
                  .author-content {
                    display: inline-block;
                  }
                }
                .span_a {
                  color: #2d8cf0;
                }
              }
              .journal_span {
                .span_a {
                  color: #2d8cf0;
                  cursor: pointer;
                  &:hover {
                    text-decoration: underline;
                  }
                }
              }
              .span_p {
                // color: #2d8cf0;
                margin-left: 5px;
              }
              p {
                margin-top: 10px;
                color: #666;
              }
              &:first-of-type {
                padding-top: 0;
              }
              &:last-of-type {
                border: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.tips-content {
  p {
    margin-bottom: 15px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
.el-slider__marks-text {
  display: none;
  &:first-of-type {
    display: inline-block;
  }
  &:last-of-type {
    display: inline-block;
  }
}
</style>
